// extracted by mini-css-extract-plugin
module.exports = {"container":"ShiftCashierHistoryCard_container__2zBGD","time":"ShiftCashierHistoryCard_time__1_imH","active":"ShiftCashierHistoryCard_active__16Iur"};